import { render, staticRenderFns } from "./DataTable3.vue?vue&type=template&id=39dc143a&scoped=true&"
import script from "./DataTable3.vue?vue&type=script&lang=js&"
export * from "./DataTable3.vue?vue&type=script&lang=js&"
import style0 from "./DataTable3.vue?vue&type=style&index=0&id=39dc143a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dc143a",
  null
  
)

export default component.exports